<template>
  <div class="app-monitor">
    <TopBar />
    <div class="monitor-container">
      <!-- 左侧导航栏 -->
      <div class="sidebar">
        <!-- <div class="logo">LOGO</div> -->
        <div class="nav-item active" @click="backToList">
          <div class="nav-icon active">
            <img
              src="../assets/alarmMonitor-b.svg"
              style="width: 100%; height: 100%"
              alt=""
              srcset=""
            />
          </div>
          <span>问题与故障</span>
        </div>
        <div class="nav-item" @click="goToApiMonitor">
          <div class="nav-icon">
            <img
              src="../assets/接口监控.svg"
              style="width: 100%; height: 100%"
              alt=""
              srcset=""
            />
          </div>
          <span>接口监控</span>
        </div>
        <div class="nav-item">
          <div class="nav-icon"></div>
          <span>看板</span>
        </div>
      </div>

      <!-- 右侧内容区域 -->
      <div class="content">
        <!-- 列表视图 -->
        <div v-if="!showDetail">
          <h1>问题与故障</h1>

          <!-- 筛选条件 -->
          <div class="filter-section-map">
            <div class="filter-section">
              <el-input v-model="sessionId" placeholder="会话id" style="width: 150px;"></el-input>
              <el-select
                v-model="brandValue"
                placeholder="手机厂商"
                style="width: 150px"
                clearable
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-select
                v-model="modelValue"
                placeholder="手机型号"
                style="width: 150px"
                clearable
              >
                <el-option
                  v-for="item in modelOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-select
                v-model="uuidValue"
                placeholder="UUID"
                style="width: 150px"
                clearable
              >
                <el-option
                  v-for="item in uuidOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-select
                v-model="timeValue"
                placeholder="时间"
                style="width: 150px"
                @change="selectAll"
              >
                <el-option
                  v-for="item in timeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select
                v-model="statusValue"
                placeholder="状态"
                style="width: 150px"
              >
                <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select
                v-model="sortValue"
                placeholder="排序"
                style="width: 150px"
              >
                <el-option
                  v-for="item in sortOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

            <el-button
              style="margin-left: 10px"
              type="primary"
              @click="fetchProblemList"
              >查询</el-button
            >
          </div>

          <!-- 问题列表表格 @row-click="showIssueDetail" -->
          <div class="table-container">
            <el-table
              :data="tableData"
              style="width: 100%; cursor: pointer"
              height="580"
            >
              <!-- width="100" -->
              <el-table-column
                prop="sessionId"
                label="会话列表"
                align="center"
              />
              <el-table-column prop="errorType" label="问题">
                <template #default="scope">
                  <div
                    v-for="(api, index) in scope.row.errorTypes"
                    :key="index"
                    style="display: flex; align-content: center"
                  >
                    <div
                      style="
                        width: 12px;
                        height: 12px;
                        border-radius: 50%;
                        background-color: red;
                        margin-top: 5px;
                      "
                    ></div>
                    <span style="margin-left: 5px">{{ api.name }}</span>
                  </div>
                  <!-- <div class="issue-title">{{ scope.row.errorType }}</div> -->
                  <!-- <div
                    style="
                      width: 100%;
                      height: 35px;
                      padding-left: 5px;
                    "
                    :style="{
                      borderLeft:
                        scope.row.solveStatus == 0
                          ? '3px solid red'
                          : '3px solid green',
                    }"
                    :tooltip-formatter="({ row }) => row.errorInfo"
                  >
                    <div class="issue-detail">{{ scope.row.errorInfo }}</div>
                  </div> -->
                </template>
              </el-table-column>
              <el-table-column label="手机信息" min-width="150" align="center">
                <template #default="scope">
                  <div>{{ scope.row.deviceModel }}</div>
                  <div>{{ scope.row.romVersion }}</div>
                  <div>操作系统: {{ scope.row.romName }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="romVersion"
                label="APP信息"
                width="150"
                align="center"
              >
              <template #default="scope">
                <p>版本信息:{{ scope.row.romVersion }}</p>
                <p v-if="scope.row.sdkLanguage">默认语言:{{ scope.row.sdkLanguage =='zh'?'中文':scope.row.sdkLanguage =='en'?'英文':'俄文' }}</p>
              </template>
            </el-table-column>
              <el-table-column
                prop="lastTime"
                label="最近发生时间"
                width="300"
                align="center"
              />
              <el-table-column
                prop="errorCount"
                label="发生次数"
                width="100"
                align="center"
              />
              <!-- <el-table-column
                prop="sdkLanguage"
                label="SDK默认语言"
                width="150"
                align="center"
              /> -->
              <el-table-column
                prop="errorCount"
                label="操作"
                width="250"
                align="center"
              >
                <template #default="scope">
                  <div style="display: flex; justify-content: space-between">
                    <p
                      class="errorCountCaoZuo"
                      style="color: #3da8ff; cursor: pointer"
                      @click="showIssueDetail(scope.row)"
                    >
                      详情
                    </p>
                    <p
                      class="errorCountCaoZuo"
                      style="color: #3da8ff; cursor: pointer"
                      @click="DownloadLog(scope.row)"
                      v-show="scope.row.logsDownUrl"
                    >
                      复制下载日志链接
                    </p>
                    <p
                      class="errorCountCaoZuo"
                      style="color: #3da8ff; cursor: pointer"
                      @click="DownBDloadLog(scope.row)"
                      v-show="scope.row.dbDownUrl"
                    >
                      复制下载数据库链接
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-container">
              <el-pagination
                v-model:current-page="currentPage"
                v-model:page-size="pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
              />
            </div>
          </div>
        </div>

        <!-- 详情视图 -->
        <div v-else>
          <div style="display: flex; justify-content: space-between">
            <div class="breadcrumb">
              <h1
                @click="backToList"
                style="cursor: pointer; text-decoration: underline"
                class="BackToUN"
              >
                问题与故障
              </h1>
              <h1 class="separator">/</h1>
              <h1 class="current">详情</h1>
            </div>
            <el-button @click="backToList">返回</el-button>
          </div>

          <!-- <h1>问题与故障 / 详情</h1> -->

          <!-- 详情内容 -->
          <div class="detail-content">
            <!-- <div class="detail-header">
              <div>
                <div class="error-title">{{ rowListArr.errorType }}</div>
                <div class="error-detail">
                  <div
                    style="width: 2px; height: 40px; margin-right: 5px"
                    :style="{ 'background-color': 'goldenrod' }"
                  ></div>
                  <div>
                    <p>
                      {{ rowListArr.errorInfo }}
                    </p>
                  </div>
                </div>
              </div>
              <el-button type="primary" @click="ResolveList">解决</el-button>
            </div> -->

            <!-- Events 图表 -->
            <div class="events-section">
              <div
                style="
                  width: 108px;
                  height: 30px;
                  padding-left: 20px;
                  padding-top: 20px;
                  background-color: transparent;
                  float: right;
                "
              >
                <!-- <el-select
                  v-model="timeValue"
                  placeholder="发生时间"
                  @change="fetchProblemListOrCharrg"
                >
                  <el-option
                    v-for="item in timeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> -->
                <el-button type="primary" @click="ResolveList"
                  >全部解决</el-button
                >
              </div>
              <div
                style="
                  width: 98.5%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  margin-top: 20px;
                  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
                  padding-left: 20px;
                  padding-bottom: 20px;
                "
              >
                <div
                  style="
                    height: 80px;
                    width: 100px;
                    background-color: rgba(0, 255, 255, 0);
                    border-radius: 5px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                  "
                >
                  <div
                    style="
                      width: 100px;
                      height: 20px;
                      background-color: rgba(0, 255, 255, 0);
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      margin-top: 10px;
                      font-size: 18px;
                    "
                  >
                    <p>Events</p>
                  </div>
                  <div
                    style="
                      width: 100px;
                      height: 20px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      margin-top: 10px;
                      font-size: 22px;
                      font-weight: 500;
                    "
                  >
                    <p>{{ errorSList.total }}</p>
                  </div>
                </div>
                <div class="events-chart" style="width: calc(100% - 100px)">
                  <LineChart
                    :activeIndex="nestNum"
                    :data="chartData"
                    :labels="chartLabels"
                  />
                  <!-- :data="chartData" :labels="chartLabels" -->
                </div>
              </div>
            </div>

            <!-- 事件信息 -->
            <div class="event-info-section">
              <h2>事件信息</h2>
              <div class="event-info-card">
                <div class="info-row">
                  <div style="padding-left: 13px">
                    <!-- <span class="info-label">ID:</span> -->
                    <span class="info-value">{{
                      errorSList.detailData[nestNum].error_type
                    }}</span>
                    <span class="info-time">{{
                      errorSList.detailData[nestNum].error_info
                    }}</span>
                  </div>
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      @click="nextTickList"
                    >
                      下一个
                    </el-button>
                    <el-button
                      type="success"
                      size="small"
                      v-show="errorSList.detailData[nestNum].solveStatus != 1"
                      @click="Resolve(errorSList.detailData[nestNum].id)"
                    >
                      解决
                    </el-button>
                  </div>
                </div>
                <div class="device-info">
                  <div
                    style="
                      width: 300px;
                      border-right: 1px solid #f0f0f0;
                      /* display: flex;
                      justify-content: space-around; */
                      padding-left: 13px;
                    "
                  >
                    <span class="ip" v-if="result">{{
                      result.provinceName
                    }}</span
                    ><span class="ip" style="margin-left: 10px" v-if="result">{{
                      result.cityName
                    }}</span>
                    <span
                      style="margin-left: 20px; cursor: pointer; color: #3da8ff"
                      @click="PositionLeflat"
                    >
                      位置
                    </span>
                  </div>
                  <div
                    style="
                      width: 200px;
                      border-right: 1px solid #f0f0f0;
                      display: flex;
                      justify-content: center;
                    "
                  >
                    <span class="device">手机型号:</span>
                    <span class="device">{{
                      errorSList.detailData[nestNum].device_model
                    }}</span>
                  </div>
                  <div
                    style="width: 250px; display: flex; justify-content: center"
                  >
                    <span class="os">操作系统版本:</span>
                    <span class="os"
                      >{{ errorSList.detailData[nestNum].rom_name }}.{{
                        errorSList.detailData[nestNum].rom_version
                      }}</span
                    >
                  </div>
                </div>

                <!-- 附加参数 -->
                <div class="extra-params">
                  <h3>附加参数</h3>
                  <div class="params-content">
                    <div class="param-item">
                      <span class="param-key">文件路径:</span>
                      <span class="param-value">{{
                        errorSList.detailData[nestNum].component_name
                      }}</span>
                    </div>
                    <div class="param-item">
                      <span class="param-key">错误信息:</span>
                      <span class="param-value">{{
                        errorSList.detailData[nestNum].error_info
                      }}</span>
                    </div>
                    <div class="param-item">
                      <span class="param-key">经度:</span>
                      <span class="param-value">{{
                        errorSList.detailData[nestNum].lng
                      }}</span>
                    </div>
                    <div class="param-item">
                      <span class="param-key">纬度:</span>
                      <span class="param-value">{{
                        errorSList.detailData[nestNum].lat
                      }}</span>
                    </div>
                    <div class="param-item">
                      <span class="param-key">详细信息:</span>
                      <VueJsonPretty
                        :data="
                          JSON.parse(errorSList.detailData[nestNum].pinout)
                        "
                        :deep="0"
                      />
                    </div>
                    <div class="param-item">
                      <span class="param-key">系统:</span>
                      <span class="param-value">{{
                        errorSList.detailData[nestNum].system
                      }}</span>
                    </div>
                    <div class="param-item">
                      <span class="param-key">uuid:</span>
                      <span class="param-value">{{
                        errorSList.detailData[nestNum].uuid
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 堆栈跟踪 -->
            <div class="stack-section">
              <h2>堆栈跟踪</h2>
              <div class="stack-content">
                <div class="stack-item">
                  <span class="stack-type">{{
                    errorSList.detailData[nestNum].error_type
                  }}</span>
                </div>
                <div class="stack-error">
                  <span class="error-line">{{
                    errorSList.detailData[nestNum].error_info
                  }}</span>
                </div>
                <div class="stack-file">
                  <span>{{ errorSList.detailData[nestNum].file_name }}</span>
                </div>
                <div class="stack-file">
                  <span>{{
                    errorSList.detailData[nestNum].component_name
                  }}</span>
                </div>
                <div class="stack-file">
                  <span>{{ errorSList.detailData[nestNum].error_method }}</span>
                </div>
              </div>
            </div>

            <!-- SDK -->
            <div class="sdk-section">
              <h2>SDK</h2>
              <div class="sdk-info">
                <div class="sdk-item">
                  <span class="sdk-label">名称:</span>
                  <span class="sdk-value">{{
                    errorSList.detailData[nestNum].sdk_name
                  }}</span>
                </div>
                <div class="sdk-item">
                  <span class="sdk-label">版本:</span>
                  <span class="sdk-value">{{
                    errorSList.detailData[nestNum].sdk_version
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 地图弹框 -->
  <el-dialog
    v-model="showMapDialog"
    title="错误发生点位"
    width="800px"
    height="600px"
  >
    <div id="map" style="width: 100%; height: 500px"></div>
  </el-dialog>
</template>

<script>
import TopBar from "./Top.vue";
import LineChart from "./LineChart.vue";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.chinatmsproviders";
import "../data/leaflet.mapCorrection.js";
import {
  getFailProblemList,
  getselectAllList,
  getfailProblemDetail,
  getfailProblemResolve,
} from "@/api/appError.js";
import rawData from "../data/city_geo_range.json";
import { enrichProvinceBounds, findLocationSafe } from "../utils/geoLocation";
// import { initGeoOffline, getCityByLatLngOffline } from '../utils/geoOffline'

export default {
  name: "AppMonitor",
  components: {
    TopBar,
    LineChart,
    VueJsonPretty,
  },
  data() {
    return {
      showDetail: false,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      sectionValue: "",
      sectionOptions: [
        {
          value: "1",
          label: "事件信息",
        },
        {
          value: "2",
          label: "堆栈跟踪",
        },
        {
          value: "3",
          label: "SDK",
        },
      ],
      chartData: [],
      chartLabels: [],
      brandValue: "",
      sessionId:'',
      brandOptions: [],
      modelValue: "",
      modelOptions: [],
      uuidValue: "",
      uuidOptions: [],
      timeValue: "3",
      timeOptions: [
        { value: "0", label: "15分钟" },
        { value: "1", label: "近3小时" },
        { value: "2", label: "近一天" },
        { value: "3", label: "近一周" },
        { value: "4", label: "近一月" },
        { value: "5", label: "近一年" },
      ],
      statusValue: "",
      statusOptions: [
        { value: "", label: "全部" },
        { value: 0, label: "未解决" },
        { value: 1, label: "已解决" },
      ],
      sortValue: 0,
      sortOptions: [
        { value: 0, label: "时间倒序" },
        { value: 1, label: "时间正序" },
      ],
      tableData: [],
      TimeValueLine: "",
      timeOptionsLine: [],
      rowListArr: {},
      errorSList: {},
      anlysisData: [],
      nestNum: 0,
      result: {},
      showMapDialog: false,
      map: null,
    };
  },
  methods: {
    async DownloadLog(row) {
      if (!row.logsDownUrl) {
        this.$message.error("日志地址不存在");
        return;
      }
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(row.logsDownUrl);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = row.logsDownUrl;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.$message.success("日志链接已复制，请在浏览器新标签页打开");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制日志链接失败");
      }
    },
    async DownBDloadLog(row) {
      if (!row.dbDownUrl) {
        this.$message.error("数据库地址不存在");
        return;
      }
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(row.dbDownUrl);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = row.dbDownUrl;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.$message.success("数据库链接已复制，请在浏览器新标签页打开");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制数据库链接失败");
      }
    },
    async Resolve(id) {
      try {
        let params = {
          ids: [],
        };
        params.ids.push(id);
        const response = await getfailProblemResolve(params);
        if (response.data.code === 200) {
          console.log(response.data.data, "fdjsifjisjfisdjfidsfs");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async ResolveList() {
      try {
        let params = {
          ids: [],
        };
        this.errorSList.detailData.map((items, indexs) => {
          // console.log(items, "fdsjifjidsjfsdifjdsfds");
          params.ids.push(items.id);
        });

        const response = await getfailProblemResolve(params);
        if (response.data.code === 200) {
          // console.log(response.data.data, "fdjsifjisjfisdjfidsfs");
        }
      } catch (error) {
        console.log(error);
      }
    },
    nextTickList() {
      if (this.nestNum < this.errorSList.detailData.length - 1) {
        this.nestNum += 1;
      } else {
        this.nestNum = 0;
      }
      // ✅ 1. 生成省级范围
      const provinces = enrichProvinceBounds(rawData);

      // ✅ 2. 查询
      this.result = findLocationSafe(
        this.errorSList.detailData[this.nestNum].lat,
        this.errorSList.detailData[this.nestNum].lng,
        provinces
      );
    },
    async selectAll() {
      try {
        let params = {
          dateType: this.timeValue,
          source: 0,
        };
        const response = await getselectAllList(params);
        if (response.data.code == 200) {
          this.brandOptions = response.data.data.brandList;
          this.modelOptions = response.data.data.modelList;
          this.uuidOptions = response.data.data.uuidList;
        }
      } catch (error) {
        console.error("获取选择项失败:", error);
      }
    },
    async fetchProblemList() {
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          order: Number(this.sortValue),
          dateType: Number(this.timeValue),
          brand: this.brandValue,
          model: this.modelValue,
          uuid: this.uuidValue,
          processStatus: this.statusValue,
          sessionId: this.sessionId
        };

        const response = await getFailProblemList(params);

        if (response.data.code === 200) {
          console.log(response.data.data, "Fdsjifjsijfisjfisfsf");
          this.tableData = response.data.data.data;
          response.data.data.data.map((item, index) => {
            let resultserr = [];
            item.errorType.split("\n").map((apiStr) => {
              // const matches = [...apiStr.matchAll(/(.*?)\s*\*\s*(\d+)/g)];
              /* const result = matches.map((item) => ({
                type: item[1].trim(),
                count: Number(item[2]),
                status: "success",
              })); */
              const result = apiStr
                ? apiStr.split("\n").map((item) => ({
                    name: item.trim(),
                  }))
                : [];
              console.log(result, "fdshufhdshfusdhfusdufhsdfs");
              resultserr.push(...result);
            });
            this.tableData[index].errorTypes = resultserr;
          });
          console.log(this.tableData, "fdsjfisjidfjsdifjidsfsd");
          this.totalCount = response.data.data.count;
        }
      } catch (error) {
        console.error("获取问题列表失败:", error);
      } finally {
        this.loading = false;
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchProblemList();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchProblemList();
    },
    async showIssueDetail(row) {
      console.log(row, "fdsjifdjisfjidsfsfds78fds");
      if (row) {
        this.rowListArr = row;
      }

      try {
        let params = {
          order: Number(this.sortValue),
          dateType: Number(this.timeValue),
          brand: this.brandValue,
          model: this.modelValue,
          uuid: this.uuidValue,
          processStatus: this.statusValue,
          sessionId: this.rowListArr.sessionId,
          // errorType: this.rowListArr.errorType,
          // fileName: this.rowListArr.fileName,
          // errorMethod: this.rowListArr.errorMethod,
        };
        const response = await getfailProblemDetail(params);
        if (response.data.code == 200) {
          this.errorSList = response.data.data;

          if (response.data.data.detailData.length > 0) {
            this.chartData = [];
            this.chartLabels = [];
            for (
              let index = 0;
              index < response.data.data.detailData.length;
              index++
            ) {
              this.chartData.push(1);
              this.chartLabels.push(
                response.data.data.detailData[index].error_time
              );
            }
          }
          // ✅ 1. 生成省级范围
          const provinces = enrichProvinceBounds(rawData);

          // ✅ 2. 查询
          this.result = findLocationSafe(
            this.errorSList.detailData[this.nestNum].lat,
            this.errorSList.detailData[this.nestNum].lng,
            provinces
          );
        }
      } catch (error) {
        console.error("获取问题详情失败:", error);
      }
      this.showDetail = true;
    },
    backToList() {
      this.showDetail = false;
      this.nestNum = 0;
    },
    goToApiMonitor() {
      this.$router.push("/api-monitor");
    },
    fetchProblemListOrCharrg() {
      this.selectAll();
      this.showIssueDetail();
    },
    PositionLeflat() {
      this.showMapDialog = true;
      this.$nextTick(() => {
        if (this.map) {
          this.map.remove();
        }
        const lat = this.errorSList.detailData[this.nestNum].lat;
        const lng = this.errorSList.detailData[this.nestNum].lng;
        if (lat && lng && lat != "undefined" && lng != "undefined") {
          this.map = L.map("map").setView([lat, lng], 15);
          L.tileLayer
            .chinaProvider("GaoDe.Normal.Map", {
              attribution: "",
            })
            .addTo(this.map);
          L.circleMarker([lat, lng], {
            radius: 8,
            fillColor: "#ff0000",
            color: "#000",
            weight: 1,
            opacity: 1,
            fillOpacity: 0.8,
          }).addTo(this.map);
        } else {
          // this.showMapDialog = false;
        }
      });
    },
  },
  mounted() {
    this.fetchProblemList();
    this.selectAll();
    // getCityByLatLngOffline(39.9042, 116.4074)
  },
};
</script>

<style scoped lang="less">
.app-monitor {
  padding-top: 60px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.monitor-container {
  display: flex;
  min-height: calc(100vh - 60px);
}

/* 左侧导航栏 */
.sidebar {
  width: 200px;
  background-color: #fff;
  border-right: 1px solid #e0e0e0;
  padding: 20px 0;

  .logo {
    padding: 0 20px 20px;
    font-weight: bold;
    font-size: 18px;
  }

  .nav-item {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #f0f0f0;
    }

    &.active {
      background-color: #e6f7ff;
      color: #1890ff;
    }

    .nav-icon {
      width: 20px;
      height: 20px;
      background-color: transparent;
      margin-right: 10px;
      border-radius: 4px;
    }

    span {
      font-size: 14px;
    }
  }
}

/* 右侧内容区域 */
.content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  max-height: calc(100vh - 100px);

  .breadcrumb {
    // background-color: #fff;
    height: 30px;
    display: flex;
    line-height: 30px;
    align-items: center;
    color: #666;
    overflow: hidden;
    margin-bottom: 10px;
    .BackToUN:hover {
      color: #1890ff;
    }
    .separator {
      margin-right: 8px;
      margin-left: 8px;
    }

    .current {
      color: #1890ff;
    }
  }

  h1 {
    color: #333;
    margin-bottom: 20px;
    font-size: 20px;
  }

  h2 {
    color: #555;
    margin: 0 0 15px;
    font-size: 16px;
  }

  h3 {
    color: #666;
    margin: 15px 0;
    font-size: 14px;
  }
  .api-list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .api-item {
      display: flex;
      align-items: center;
      gap: 8px;

      .api-icon {
        width: 12px;
        height: 12px;
        border-radius: 50%;

        &.success {
          background-color: #52c41a;
        }

        &.warning {
          background-color: #faad14;
        }
      }
    }
  }
}

/* 筛选条件 */
.filter-section-map {
  display: flex;
  // justify-content: space-between;
  .filter-section {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .filter-select {
      padding: 8px 12px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      font-size: 14px;
      min-width: 120px;
    }

    .search-btn {
      padding: 0 20px;
      background-color: #1890ff;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      height: 32px;
    }
  }
}

/* 表格容器 */
.table-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  // overflow: hidden;
  padding: 20px;
  height: 650px;

  .errorCountCaoZuo:hover {
    color: #0856ff !important;
    text-decoration: underline !important;
  }

  .el-table .el-table__cell {
    padding: 0px !important;
  }
  /* 修改表格行悬停时的背景色 */
  .el-table {
    .el-table__body tr:hover > td {
      cursor: pointer !important; /* 自定义颜色 */
    }
  }
}

/* 分页容器 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  // margin-top: 20px;
  padding-top: 20px;
  // border-top: 1px solid #f0f0f0;
}

/* 问题列表表格 */
.issue-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
  }

  th {
    background-color: #fafafa;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  td {
    font-size: 14px;
    color: #666;
  }

  .issue-title {
    // font-weight: 600;
    margin-bottom: 8px;
    color: #333;
  }

  .issue-detail {
    font-size: 13px;
    color: #999;
    margin-bottom: 8px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .issue-file {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #1890ff;

    .file-icon {
      width: 12px;
      height: 12px;
      background-color: #1890ff;
      margin-right: 6px;
      border-radius: 2px;
    }
  }
}

/* 详情内容 */
.detail-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 详情头部 */
.detail-header {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  // gap: 10px;

  .error-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }

  .error-detail {
    font-size: 14px;
    color: #666;
    height: 60px;
    line-height: 5px;
    display: flex;
    align-items: center;
  }

  .error-file {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;

    .file-icon {
      width: 14px;
      height: 14px;
      background-color: #1890ff;
      margin-right: 8px;
      border-radius: 2px;
    }
  }

  .solve-btn {
    align-self: flex-start;
    padding: 6px 16px;
    background-color: #52c41a;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;

    &.small {
      padding: 4px 12px;
      font-size: 12px;
    }
  }
}

/* Events 图表 */
.events-section {
  background-color: #fff;
  // padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .events-chart {
  }
}

/* 事件信息 */
.event-info-section {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .event-info-card {
    .info-row {
      display: flex;
      /* align-items: center;
      gap: 15px; */
      margin-bottom: 7px;
      justify-content: space-between;

      .info-label {
        font-size: 14px;
        color: #666;
      }

      .info-value {
        font-size: 14px;
        color: #3da8ff;
        font-weight: 500;
        margin-left: 5px;
      }

      .info-time {
        margin-left: 40px;
        font-size: 14px;
        color: #999;
      }

      .next-btn {
        padding: 4px 12px;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        background-color: #fff;
        cursor: pointer;
        font-size: 12px;
        margin-left: auto;
        color: black;
      }
    }

    .device-info {
      display: flex;
      // gap: 15px;
      margin-bottom: 7px;
      font-size: 14px;
      color: #666;
      padding-top: 7px;
      border-top: 1px solid #f0f0f0;
    }

    .extra-params {
      border-top: 1px solid #f0f0f0;
      padding-top: 15px;

      .params-content {
        background-color: #fafafa;
        padding: 15px;
        border-radius: 4px;
        font-size: 14px;

        .param-item {
          display: flex;
          margin-bottom: 8px;

          .param-key {
            width: 100px;
            color: #666;
          }

          .param-value {
            color: #333;
          }
        }
      }
    }
  }
}

/* 堆栈跟踪 */
.stack-section {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .stack-content {
    background-color: #fafafa;
    padding: 15px;
    border-radius: 4px;
    font-size: 14px;

    .stack-item {
      margin-bottom: 10px;

      .stack-type {
        font-weight: 600;
        color: #cf1322;
      }
    }

    .stack-file {
      margin-left: 20px;
      margin-bottom: 5px;
      color: #666;
    }

    .stack-error {
      margin-left: 20px;
      margin-top: 10px;

      .error-line {
        color: #cf1322;
        font-family: "Courier New", monospace;
      }
    }
  }
}

/* SDK */
.sdk-section {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .sdk-info {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .sdk-item {
      display: flex;

      .sdk-label {
        width: 80px;
        color: #666;
        font-size: 14px;
      }

      .sdk-value {
        color: #333;
        font-size: 14px;
      }
    }
  }
}
</style>
